module.exports = __webpack_public_path__ + "static/media/equipment33.51eeb5f6.jpg";